import api from "@/api/api";
import * as Helpers from "@/helpers";
import moment from "moment";

function fornum(n) {
  return parseFloat(n).toLocaleString("pt", {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4
  });
}

export default {
  async Ativo({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("produto_fracionado_ativo", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setAtivo", resp.data.ativo);
      })
      .catch(() => {
        // Helpers.logout();
      });
  },

  async Itens({ commit, dispatch }, params) {
    const headers = Helpers.iniciarRequisicao();
    commit("setAllFormParcelas", []);
    commit("setItens", []);
    commit("setParcelas", []);
    return await api
      .get("produto_fracionado", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setProduto", resp.data.produto);
        let pro = resp.data.produto[0];
        if (resp.data.itens.length > 0) {
          let d1 = moment(resp.data.itens[0].data_emissao, "DD/MM/YYYY");
          let d2 = moment(resp.data.itens[1].data_emissao, "DD/MM/YYYY");
          var t = d2.diff(d1, "days");
          var qtde = 0;
          resp.data.itens.forEach((v, i) => {
            qtde += parseFloat(v.qtde_solicitada);
            commit("setForm", {
              index: i,
              value: v.qtde_solicitada,
              tempo: t,
              diautil: resp.data.itens[0].diautil,
              qtde: qtde
            });
          });
          dispatch("Setar", {
            pro: pro,
            idpedido: resp.data.itens[0].idpedido
          });
        }
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Store({ state }) {
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "post",
      url: "produto_fracionado",
      headers,
      data: state.parcelas
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        return true;
        // commit("setParcelas", resp.data.itens);
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Delete({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .delete("produto_fracionado/" + params.id, {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", []);
        commit("setParcelas", []);
        commit("setFormParcela", "");
      })
      .catch(() => {
        // Helpers.logout();
      });
  },
  async Setar({ commit, state }, params) {
    commit("setItens", []);
    commit("setParcelas", []);
    let { pro, idpedido } = params;
    let parcelas = state.form.parcelas;
    let tem = state.form.tempo;
    let diautil = state.form.diautil;
    let sal = parseFloat(pro.estoque);
    let tmr = parseFloat(pro.tempo_medio_ressuprimento);
    let cmd = parseFloat(pro.consumo_medio_mensal) / diautil;
    let fpa = parcelas.length;
    let f = fpa * tem + tmr;
    let con = 0;
    let par = 0;
    let rep = 0;
    let dtc = [];
    for (let i = 0; i < f; i++) {
      let dti = moment()
        .add(i, "days")
        .format("DD/MM/YYYY");
      if (con == 0 && par < fpa) {
        con = tem;
        commit("setCalcular", {
          data: dti,
          tipo: "Parcela " + (par + 1),
          entrada: "0,00",
          saida: "0,00",
          saldo: fornum(sal)
        });
        let day = par == 0 ? tmr : tem;
        let dat = par == 0 ? moment().format("DD/MM/YYYY") : dtc[par - 1].dtc;
        dtc[par] = {
          dte: dti,
          dtc: moment(dat, "DD/MM/YYYY")
            .add(day, "days")
            .format("DD/MM/YYYY"),
          sal: sal
        };
        par++;
      }
      if (dtc[rep] && dti == dtc[rep].dtc && rep < fpa) {
        sal += parcelas[rep];
        commit("setCalcular", {
          data: dti,
          tipo: "Entrada " + (rep + 1),
          entrada: fornum(parcelas[rep]),
          saida: "0,00",
          saldo: fornum(sal)
        });
        commit("setParcela", {
          parcela: rep + 1,
          idpedido: idpedido,
          idproduto: pro.idproduto,
          id_grupo: pro.id_grupo,
          data_emissao: dtc[rep].dte,
          data_chegada: dtc[rep].dtc,
          saldo_inicial: dtc[rep].sal,
          qtde_solicitada: parcelas[rep],
          saldo_futuro: sal - cmd > 0 ? sal - cmd : sal,
          desvio_padrao: "",
          consumo_medio_mensal: pro.consumo_medio_mensal,
          estoque_seguranca: pro.estoque_seguranca,
          ponto_pedido: pro.ponto_pedido,
          estoque_maximo: pro.estoque_maximo,
          diautil: diautil,
          cob:
            pro.consumo_medio_mensal > 0
              ? dtc[rep].sal / pro.consumo_medio_mensal
              : 0,
          v_consumo_medio_mensal: pro.v_consumo_medio_mensal,
          v_qtde_solicitada: fornum(parcelas[rep]),
          v_saldo_inicial: fornum(dtc[rep].sal),
          v_saldo_futuro: fornum(sal - cmd > 0 ? sal - cmd : sal),
          v_estoque_seguranca: pro.v_estoque_seguranca,
          v_ponto_pedido: pro.v_ponto_pedido,
          v_estoque_maximo: pro.v_estoque_maximo,
          v_cob: fornum(
            pro.consumo_medio_mensal > 0
              ? dtc[rep].sal / pro.consumo_medio_mensal
              : 0
          )
        });
        rep++;
      }
      sal = sal - cmd > 0 ? sal - cmd : 0;
      commit("setCalcular", {
        id: i + 1,
        data: dti,
        tipo: "Saída",
        entrada: "0,00",
        saida: fornum(sal > cmd ? cmd : sal),
        saldo: fornum(sal)
      });
      con--;
    }
  }
};
